<template>
  <div class="water-light-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>θ > θ_c → 全反射$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Tank -->
          <rect x="20" y="40" width="80" height="120" fill="rgba(0, 210, 255, 0.1)" stroke="#888" />
          
          <!-- The Water Stream (Parabolic) -->
          <path :d="streamPath" fill="none" stroke="rgba(0, 210, 255, 0.4)" stroke-width="12" stroke-linecap="round" />

          <!-- The Light Source -->
          <g transform="translate(10, 100)">
             <line x1="0" y1="0" x2="30" y2="0" stroke="#fff700" stroke-width="4">
                <animate attributeName="opacity" values="1;0.5;1" dur="0.5s" repeatCount="indefinite" />
             </line>
          </g>

          <!-- Trapped Light Path through the stream -->
          <path :d="streamPath" fill="none" stroke="#fff700" stroke-width="2" stroke-dasharray="10, 10">
             <animate attributeName="stroke-dashoffset" from="100" to="0" dur="2s" repeatCount="indefinite" />
          </path>
          
          <text x="120" y="40" fill="#fff700" font-size="10">光被“锁”在水流中</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>全反射：现代光纤通信的鼻祖</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>1870年廷德尔演示了这一著名实验：光在下落的水流内部发生多次**全反射**，顺着弯曲的水柱传播，就像被水流引路一样。这是因为水对空气是光密介质，当入射角大于临界角时，光不会折射出水流。这一物理原理直接启发了现代**光纤通信**技术。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WaterStreamLightGuideViz',
  props: { knowledgePoint: { type: String, default: '' } },
  computed: {
    streamPath() {
       // A simple parabolic curve for the water stream
       return "M 100,100 Q 150,100 200,160 T 300,220";
    }
  }
}
</script>

<style scoped lang="scss">
.water-light-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
